module.exports = __webpack_public_path__ + "static/img/kaishu_benefit_btn2.6dc59243.png";